import { useQuery } from '@tanstack/react-query';
import { Merchant } from 'pages/MerchantPortal/merchant-portal.types';
import merchantService from 'services/api/merchants.api';

const DEFAULT_QUERY_KEY = 'merchants';

export default function useMerchantsMock() {
  const queryKey = [DEFAULT_QUERY_KEY];

  const { data, isLoading, isError } = useQuery<Merchant[]>({
    queryKey,
    queryFn: () => merchantService.getMerchantsMock(),
    refetchOnWindowFocus: false,
  });

  return {
    merchantsData: data ?? [],
    areMerchantsLoading: isLoading,
    isMerchantsError: isError,
    queryKey,
  };
}
